import { FLAVORS } from "@/constants/flavors";
import { Eyebrow } from "@/components/media/Sections";

/**
 * The drinks themselves, each with its own color. Colors stay as accents and glows
 * on the dark base so the black/yellow identity stays intact.
 */
export const FlavorWall = () => (
  <>
    <Eyebrow>THE PRODUCT</Eyebrow>
    <h2 className="neon mt-3 text-4xl leading-tight sm:text-5xl">
      Every flavor has its <span className="text-primary">own personality.</span>
    </h2>
    <p className="mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">
      This is what people line up for. Operators learn to build every one of these to spec.
    </p>

    <div
      data-testid="flavor-wall"
      className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5"
    >
      {FLAVORS.map((f) => (
        <div
          key={f.id}
          data-testid={`flavor-${f.id}`}
          className="group relative overflow-hidden rounded-sm border border-border bg-[#141414] p-4 transition-all duration-300 hover:-translate-y-1"
          style={{ "--accent": f.color }}
        >
          <div
            className="pointer-events-none absolute -inset-16 opacity-0 transition-opacity duration-500 group-hover:opacity-100"
            style={{
              background: `radial-gradient(circle at 50% 30%, ${f.color}55, transparent 62%)`,
            }}
          />
          <div
            className="absolute inset-x-0 top-0 h-[3px] transition-all duration-300 group-hover:h-[5px]"
            style={{ backgroundColor: f.color }}
          />
          <img
            src={f.image}
            alt={f.name}
            loading="lazy"
            className="relative mx-auto h-28 w-auto object-contain transition-transform duration-300 group-hover:scale-110 sm:h-32"
          />
          <div
            className="mono relative mt-3 text-center text-[9px] leading-tight tracking-widest transition-colors"
            style={{ color: f.color }}
          >
            {f.name.toUpperCase()}
          </div>
        </div>
      ))}
    </div>
  </>
);

/** Thin animated color bar made from the drink palette — a divider with brand meaning. */
export const FlavorBar = ({ testId = "flavor-bar" }) => (
  <div data-testid={testId} className="flex h-1.5 w-full">
    {FLAVORS.map((f) => (
      <span
        key={f.id}
        className="h-full flex-1 transition-all duration-300 hover:flex-[2]"
        style={{ backgroundColor: f.color }}
      />
    ))}
  </div>
);
